/* eslint-disable @typescript-eslint/no-namespace */

export enum ResultsEventTypes {
  'total-co2-extension',
  'total-co2-list',
  'bar-chart',
  'data-grid',
  'sankey',
  'geometry-loaded'
}

export type ResultsEventKey = 'total-co2-extension' | 'total-co2-list' | 'bar-chart' | 'data-grid' | 'sankey' | 'geometry-loaded';

/**
 * Represents an event in the results tab.
 * 
 * @property {string} key - A unique identifier for the event identifying the source of the event.
 * @property {string} eventType - The type of the event.
 * @property {number} [viewerIndex] - An optional index indicating the viewer associated with the event.
 * @property {number | string} [groupKey] - An optional key representing the Key associated with the event.
 */
export interface ResultsEvent {
  key: ResultsEventKey;
  eventType: string;
  viewerIndex?: number;
  groupKey?: number | string;
}

export namespace ResultsEvents {
  export const SELECTION_CHANGED: string = "selectionChanged";
}